<template>
  <div v-if="loaded" class="add-association uk-container">
    <vk-breadcrumb>
      <vk-breadcrumb-item href="/administration">Union Member List</vk-breadcrumb-item>
      <vk-breadcrumb-item>Edit {{formatAssociation(associationType)}}</vk-breadcrumb-item>
    </vk-breadcrumb>
    <h1>Edit Member {{formatAssociation(this.associationType)}}</h1>
    <h2>{{formatAssociation(this.associationType)}} Entry</h2>
    <label for="name">Union Member Name</label>
    <p id="name" class="uk-text-bold">{{this.memberInfo.fName + " " + this.memberInfo.lName + " - " + this.memberInfo.bookNum}}</p>
    <form @submit.prevent="putAssociation">
      <label>{{formatAssociation(this.associationType)}} Date (Required)</label>
      <el-date-picker v-model="date" type="datetime" format="MM/dd/yy hh:mm A" :default-value="this.date" :value="this.date"></el-date-picker>
      <label for="description">Description</label>
      <textarea class="uk-textarea" name="" id="description" cols="100" rows="10" v-model="description"></textarea><br>
      <div class="uk-margin-bottom" v-if="this.associationType === 'bookings'">
        <label for="employed">Currently Employed</label>
        <label for="employed"><input class="uk-checkbox" type="checkbox" id="employed" v-model="employed"> Yes</label>
      </div>
      <input class="uk-button uk-button-primary" type="submit" value="Submit">
    </form>
  </div>
</template>



<script>
import AssociationsApi from "@/utils/api/associations";

export default {
  name: "EditAssociation",
  data() {
    return {
      associationType: this.$route.params.association,
      associationId: this.$route.params.id,
      memberInfo: null,
      date: "",
      time: "",
      description: "",
      employed: false,
      loaded: false,
      prevPath: null
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => (vm.prevPath = from.fullPath));
  },
  created() {
    AssociationsApi.getAssociation(
      this.$cookie.get("iwl_apiToken"),
      this.associationType,
      this.associationId
    )
      .then(res => {
        this.memberInfo = res[0].member;
        this.date = res[0].date;
        this.description = res[0].description;
        this.employed = res[0].currentlyEmployed;
        this.loaded = true;
      })
      .catch(err => console.log(err));
  },
  methods: {
    formatAssociation(text) {
      return text.charAt(0).toUpperCase() + text.slice(1, -1);
    },
    formatDate(date) {
      var d = new Date(date);
      return d.toLocaleDateString("en-US", {
        month: "numeric",
        day: "numeric",
        year: "2-digit",
        hour: "numeric",
        minute: "numeric"
      });
    },
    putAssociation() {
      var info = {};
      if (this.associationType === "bookings") {
        info["currently_employed"] = this.employed;
      }
      info["description"] = this.description;
      info["date"] = this.date;
      console.log(info);

      AssociationsApi.putAssociation(
        this.$cookie.get("iwl_apiToken"),
        this.associationType,
        this.associationId,
        info
      )
        .then(res => {
          console.log(res);
          this.$router.push(this.prevPath);
        })
        .catch(err => console.log(err));
    }
  }
};
</script>

<style scoped>
.add-association {
  text-align: start;
}
h4 {
  margin-bottom: 0px;
}
input,
textarea {
  margin-bottom: 20px;
}
input[type="checkbox"] {
  margin-bottom: 0px;
}
p {
  margin-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin_edit_association.vue